import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_CheckUrlRegistEmail = {
  url_token: string;
};

export const checkUrlRegistEmail = (data: I_CheckUrlRegistEmail) => {
  return axios.post(`${API_URL_MAIN}/confirm_token`, data,
  );
};
